/**
 * It's a generated file, preferable to extend this in external file
 */
import {ServerTypeName} from 'common/enums';
import * as yup from 'common/yup';
import {AbstractServer} from '../Abstract/AbstractServer';
import {serverTypeNameSchema} from '../ServerTypeName';

export const BiscomServer = AbstractServer.shape({
   typeName: serverTypeNameSchema.default(ServerTypeName.BISCOM),
   // ServerType: yup.string().oneOf(enums.ServerType).required(),
   toAddresses: yup.array().of(yup.string()),
   ccAddresses: yup.array().of(yup.string()),
   bccAddresses: yup.array().of(yup.string()),
   subject: yup.string(),
   secureNote: yup.string(),
   emailNotification: yup.string(),
   secure: yup.boolean(),
   expire: yup.boolean(),
   expirationDate: yup.idString(),
   message: yup.bool(),
});
export type IBiscomServer = yup.InferType<typeof BiscomServer>;
